import * as firebase from 'firebase';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB8Yxe0xGf2ODiZwC1GOE4eg0Ua-DScM_k',
  authDomain: 'ttruck-times.firebaseapp.com',
  databaseURL: 'https://ttruck-times.firebaseio.com',
  projectId: 'ttruck-times',
  storageBucket: 'ttruck-times.appspot.com',
  messagingSenderId: '946673916056',
};

export default () => firebase.initializeApp(FIREBASE_CONFIG);



// WEBPACK FOOTER //
// ./src/App/initializers/firebase.js